import script from "./AppModalNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./AppModalNotification.vue?vue&type=script&setup=true&lang=js"

import "./AppModalNotification.vue?vue&type=style&index=0&id=3e3da9d5&lang=scss"

const __exports__ = script;

export default __exports__